import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { TNInfoCard } from './TNInfoCard'

export const TNInfoCardRegistration = createRegisterableComponent(
    'tn-home-info-card',
    () => <TNInfoCard />,
)
